import { API_BASE_URL } from '../config';
import {
  HsmContact,
  HsmContactBatch,
  HsmContactBatchRequest,
  HsmBatchUpdateRequest
} from '../types';

// ==================== CONTACT BATCHES ====================

export async function fetchBatches(accessToken: string): Promise<HsmContactBatch[]> {
  const response = await fetch(`${API_BASE_URL}/hsm/batches`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao carregar lotes');
  }

  const payload = await response.json();
  return payload.data || payload || [];
}

export async function fetchBatch(
  batchId: number,
  accessToken: string
): Promise<HsmContactBatch> {
  const response = await fetch(`${API_BASE_URL}/hsm/batches/${batchId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao carregar lote');
  }

  const payload = await response.json();
  return payload.data || payload;
}

export async function createBatch(
  data: HsmContactBatchRequest,
  accessToken: string
): Promise<HsmContactBatch> {
  const response = await fetch(`${API_BASE_URL}/hsm/batches`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao criar lote');
  }

  const payload = await response.json();
  return payload.data || payload;
}

export async function updateBatch(
  batchId: number,
  data: HsmContactBatchRequest,
  accessToken: string
): Promise<HsmContactBatch> {
  const response = await fetch(`${API_BASE_URL}/hsm/batches/${batchId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao atualizar lote');
  }

  const payload = await response.json();
  return payload.data || payload;
}

export async function deleteBatch(
  batchId: number,
  accessToken: string
): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/hsm/batches/${batchId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao excluir lote');
  }
}

export async function fetchBatchContacts(
  batchId: number,
  accessToken: string
): Promise<HsmContact[]> {
  const response = await fetch(`${API_BASE_URL}/hsm/batches/${batchId}/contacts`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao carregar contatos do lote');
  }

  const payload = await response.json();
  return payload.data || payload || [];
}

export async function updateContactBatch(
  contactId: number,
  data: HsmBatchUpdateRequest,
  accessToken: string
): Promise<HsmContact> {
  const response = await fetch(`${API_BASE_URL}/hsm/contacts/${contactId}/batch`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao atualizar lote do contato');
  }

  const payload = await response.json();
  return payload.data || payload;
}
